import Vue from 'vue';
import { targetCompanyDataTemplate, targetLesseeDataTemplate } from '@/components/RentAdjustment/Store';
import rootStore from '@/store';

const state = {
    companyIdOriginal: '',
    companyIdTarget: '',
    isNewCompany: null,
    companyTargetList: [],
    targetCompany: {
        new: {
            companyIdTarget: '',
            newCompanyData: targetCompanyDataTemplate,
            newLesseeData: targetLesseeDataTemplate,
        },
        existing: {
            companyIdTarget: '',
            newCompanyData: targetCompanyDataTemplate,
            newLesseeData: targetLesseeDataTemplate,
        }
    },
    isNewCompanyFormChanged: false,
}

const mutations = {
    SET_COMPANY_ID_ORIGINAL(state, value) {
        state.companyIdOriginal = value;
    },
    SET_COMPANY_ID_TARGET(state, value) {
        state.companyIdTarget = value;
    },
    SET_IS_NEW_COMPANY(state, value) {
        state.isNewCompany = value;
    },
    SET_COMPANY_TARGET_LIST(state, value) {
        state.companyTargetList = value;
    },

    SET_TARGET_COMPANY_NEW(state, { companyIdTarget, newCompanyData, newLesseeData }) {

        state.companyIdTarget = companyIdTarget;
        state.targetCompany.new.newCompanyData = { ...state.targetCompany.new.newCompanyData, ...newCompanyData };
        state.targetCompany.new.newLesseeData = { ...state.targetCompany.new.newLesseeData, ...newLesseeData };
        state.targetCompany.new.companyIdTarget = companyIdTarget;
    },
    SET_TARGET_COMPANY_EXISTING(state, { companyIdTarget, newCompanyData, newLesseeData }) {
        state.companyIdTarget = companyIdTarget;
        state.targetCompany.existing.newCompanyData = { ...state.targetCompany.existing.newCompanyData, ...newCompanyData };
        state.targetCompany.existing.newLesseeData = { ...state.targetCompany.existing.newLesseeData, ...newLesseeData };
        state.targetCompany.existing.companyIdTarget = companyIdTarget;
    },
    RESET_NEW_COMPANY_DATA(state) {
        state.newCompanyData = {
            companyName: '',
            provinceName: '',
            cityName: '',
            districtName: '',
            village: '',
            postalCode: '',
            companyAddress: '',
            companyAktaAddress: '',
            citizenship: '',
            companyNameNPWP: '',
            companyNpwp15: '',
            companyNpwp16: '',
            companyNpwp22: '',
            companyPhone: '',
            citizenship: '',
            source: '',
        };
    },

    // Company Lessee Data Mutations
    SET_COMPANY_LESSEE_DATA(state, value) {
        state.newLesseeData = { ...state.newLesseeData, ...value };
    },
    RESET_COMPANY_LESSEE_DATA(state) {
        state.newLesseeData = {
            picName: "",
            picPhone: "",
            picDivision: "",
            picPosition: "",
        };
    },
    SET_IS_NEW_COMPANY_DATA_CHANGED(state, value) {
        state.isNewCompanyFormChanged = value
    },
}

const actions = {
    async fetchCompanyTargetList({ commit }, payload) {
        commit('SET_LOADING', true)
        try {
            // Replace with actual API endpoint
            const response = await Vue.prototype.$http.get(process.env.GET_COMPANY_TARGET_LIST, {
                headers: { "Asani-Token": localStorage.getItem("jwt") },
            })
            commit('SET_COMPANY_TARGET_LIST', response.data.content || [])
            return response.data.content || []
        } catch (error) {
            commit('SET_ERROR', error.message || 'Failed to fetch company list')
            console.error('Error fetching company list:', error)
            return []
        } finally {
            commit('SET_LOADING', false)
        }
    },
    updateCompanyIdOriginal({ commit }, value) {
        commit('SET_COMPANY_ID_ORIGINAL', value);
    },
    async updateCompanyIdTarget({ commit }, value) {
        commit('SET_COMPANY_ID_TARGET', value);

        try {
            const response = await Vue.prototype.$http.post(process.env.GET_DETAIL_LESSEE, {
                companyId: value.toString(),
                companyStatus: "old"
            }, {
                headers: { 'Asani-Token': localStorage.getItem('jwt') }
            });
            if (response.data.status !== 200) {
                return {
                    isSuccess: false,
                    message: response.data.message
                }
            }
            let { detailLessee, kabkot, kecamatan, province } = response.data.data;
            detailLessee = detailLessee[0];
            kabkot = kabkot[0];
            kecamatan = kecamatan[0];
            province = province[0];

            // fetch provinces, cities, and districts for select options
            rootStore.dispatch('others/fetchProvinces', null, { root: true });
            if (province) {
                rootStore.dispatch('others/fetchCities', (province.provinceId || '').toString(), { root: true });
            }
            if (kabkot) {
                rootStore.dispatch('others/fetchDistricts', (kabkot.kabKotId || '').toString(), { root: true });
            }
            const newCompanyData = {
                companyId: detailLessee.companyId || 0,
                companyName: detailLessee.companyName || '',
                provinceName: (province.provinceName || '').toString(),
                cityName: (kabkot.kabKotName || '').toString(),
                districtName: (kecamatan.kecamatanName || '').toString(),
                village: (detailLessee.companyKelurahan || '').toString(),
                postalCode: detailLessee.companyZip || '',
                companyAddress: detailLessee.companyAddress || '',
                companyAktaAddress: detailLessee.aktaAddress || '',
                citizenship: detailLessee.citizenship || '',
                companyNameNPWP: detailLessee.companyNameNPWP || '',
                companyNpwp15: detailLessee.companyNPWP || '',
                companyNpwp16: detailLessee.companyNPWP16 || '',
                companyNpwp22: detailLessee.companyNPWP22 || '',
                companyPhone: detailLessee.companyPhone || '',
                source: detailLessee.source || ''
            }
            console.log('Fetched company data:', newCompanyData)
            const newLesseeData = {
                lesseeId: detailLessee.userId || 0,
                picName: detailLessee.userName || "",
                picPhone: detailLessee.userPhone || "",
                picDivision: detailLessee.userDivision || "",
                picPosition: detailLessee.userPosition || "",
            }

            commit('SET_TARGET_COMPANY_EXISTING',
                {
                    companyIdTarget: detailLessee.companyId || 0,
                    newCompanyData,
                    newLesseeData,
                }
            );
            commit('RESET_UNITS');

            return {
                isSuccess: true,
                data: {
                    newCompanyData,
                    newLesseeData
                }
            }
        } catch (error) {
            const errorMessage = error.response && error.response.data && error.response.data.message ? error.response.data.message
                : 'An error occurred while fetching company data.';
            return {
                isSuccess: false,
                message: errorMessage
            }
        }
    },
    updateIsNewCompany({ commit }, { value }) {
        commit('SET_IS_NEW_COMPANY', value);
        commit('RESET_UNITS');
    },
    async updateNewCompanyData({ commit, state }, { newCompanyData, newLesseeData }) {
        const { id: transferUnitId, isNewCompany } = state
        commit('SET_LOADING', true);
        try {
            const response = await Vue.prototype.$http.post(process.env.SAVE_TRANSFER_UNIT_DATA, {
                id: transferUnitId,
                action: 'save-lessee',
                companyData: newCompanyData,
                lesseeData: newLesseeData
            }, {
                headers: { 'Asani-Token': localStorage.getItem('jwt') }
            });
            if (response.data.status === 200) {
                const { content } = response.data
                if (isNewCompany) {
                    commit('SET_TARGET_COMPANY_NEW', {
                        companyIdTarget: content.companyId || 0,
                        newCompanyData: {
                            ...newCompanyData,
                            companyId: content.companyId || 0
                        },
                        newLesseeData: {
                            ...newLesseeData,
                            lesseeId: content.lesseeId || 0
                        }
                    });
                } else {
                    commit('SET_TARGET_COMPANY_EXISTING', {
                        companyIdTarget: newCompanyData.companyId,
                        newCompanyData,
                        newLesseeData
                    });
                }
                return {
                    isSuccess: true
                };
            } else {
                return {
                    isSuccess: false,
                    message: response.data.message
                }
            }
        } catch (error) {
            const errorMessage = error.response && error.response.data && error.response.data.message ? error.response.data.message
                : 'An error occurred while saving the data.';
            return {
                isSuccess: false,
                message: errorMessage
            };
        } finally {
            commit('SET_LOADING', false);
        }
    },
}

const getters = {
    getCompanyIdOriginal: (state) => state.companyIdOriginal,
    getCompanyIdTarget: (state) => state.companyIdTarget,
    getIsNewCompany: (state) => state.isNewCompany,
    getNewCompanyData: (state) => state.newCompanyData,
    getTargetCompany: (state) => state.targetCompany,
    getIsNewCompanyFormChanged: (state) => state.isNewCompanyFormChanged,
    getCompanyTargetOptions: function (state) {
        return state.companyTargetList.map((company) => ({
            value: company.companyId,
            label: company.companyName,
            disabled: Boolean(company.message),
            additionalMessage: company.message
        }));
    }
}

export default {
    state,
    mutations,
    actions,
    getters,
}


// WEBPACK FOOTER //
// ./src/components/RentAdjustment/FormTabs/Detail/DetailFormStep/ChooseTargetCompany/store.js